export default "__VITE_ASSET__va$9JMEx__"